import {disableFullscreenIfEnabled} from '../../gameClient/webgl/fullscreenFixer';
import { openPoll } from '../../general/modules/pollWindow';

export class PollingWindowHandler {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public handle(params: any): void {
        openPoll(params);
        disableFullscreenIfEnabled();
    }
}
